import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-carriers',
  templateUrl: './admin-carriers.component.html',
  styleUrls: ['./admin-carriers.component.scss'],
})
export class AdminCarriersComponent implements OnInit {

  tabClicked = "active";
  carriersList: any;
  editCarrier: any;
  index: any;
  status: any;
  deleteApiPop: string = 'N';
  loading = true
  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router) {
    this.getCarriersList("ACTIVE");
  }

  populateTabData(triggered) {
    this.tabClicked = triggered;
  }


  getCarriersList(status) {
    this.g.loaderDisplay = "display";
    this.api.adminGetCarrierList(status, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      if (data.length === 0 && status === "ACTIVE") {
        this.router.navigate(['/admin/adminCarriersList']);
      }
      else {
        this.carriersList = data;
      }
    },
      err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });

  }


  modifyStatus() {
    this.g.loaderDisplay = "display";
    this.api.adminDeleteCarrierInfo(this.index.carrierId, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.carriersList = data;
      this.getCarriersList("IN_ACTIVE");
      this.alertService.success(data['message']);
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });

  }

  getCarriersManage(m: any = {}, type = '') {
    if (type == 'SD') {
      this.router.navigate(['/admin/adminManageShiftDelivery', { type, id: m.carrierId }]);
    } else if (type == 'FE') {
      this.router.navigate(['/admin/adminManageFedEx', { type, id: m.carrierId }]);
    } else if (type == 'SF') {
      this.router.navigate(['/admin/adminManageShadowFax', { type, id: m.carrierId }]);
    } else if (type == 'BD') {
      this.router.navigate(['/admin/adminManageBlueDart', { type, id: m.carrierId }]);
    } else if (type == 'DN') {
      this.router.navigate(['/admin/adminManageDunzo', { type, id: m.carrierId }]);
    } else if (type == 'DZ') {
      this.router.navigate(['/admin/adminManageDotZot', { type, id: m.carrierId }]);
    } else if (type == 'GT') {
      this.router.navigate(['/admin/adminManageGati', { type, id: m.carrierId }]);
    } else if (type == 'VS') {
      this.router.navigate(['/admin/adminManageVamaship', { type, id: m.carrierId }]);
    } else if (type == 'WF') {
      this.router.navigate(['/admin/adminManageWeFast', { type, id: m.carrierId }]);
    } else if (type == 'PR') {
      this.router.navigate(['/admin/adminManagePickrr', { type, id: m.carrierId }]);
    } else if (type == 'SY') {
      this.router.navigate(['/admin/adminManageShipyaari', { type, id: m.carrierId }]);
    } else if (type == 'SG') {
      this.router.navigate(['/admin/adminManageShippigo', { type, id: m.carrierId }]);
    } else if (type == 'DE') {
      this.router.navigate(['/admin/adminManageDelhivery', { type, id: m.carrierId }]);
    }
    this.g.loaderDisplay = "display";
    this.api.adminGetCarrierInfoById(m.carrierId, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.editCarrier = data;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  tabChange() { }

  closePopup() {
    this.deleteApiPop = 'n';
  }

  ngOnInit() { }

  testConnection(c) {

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/testCarrierConnection', {
      "carrierId": Number(c.carrierId),
      "organizationId": c.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Success', data['message']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        });
  }


  updateStatus(carrier, index) {

    let api = "";
    this.g.loaderDisplay = "display";
    if (carrier.status === "ACTIVE") {
      api = 'api/deActivateCarrier';
      carrier.status = "IN_ACTIVE";
    } else {
      api = 'api/activateCarrier';
      carrier.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + api, {
      "organizationId": this.user.organizationId,
      "status": carrier.status,
      "carrierId": carrier.carrierId
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.carriersList.splice(index, 1)
          this.alertService.success(data['message']);
          /*     if (this.tabClicked === "ACTIVE") {
            this.getCarriersList("ACTIVE");
            }
            else{
            this.getCarriersList("IN_ACTIVE");
            } */
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });

  }

  deleteCarrier(data) {
    this.deleteApiPop = 'Y';
    this.index = data;
  }

}
